import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* CTA Section */}
      <div className="border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <div className="max-w-3xl">
            <p className="text-sm text-white/50 mb-4 tracking-wide uppercase">Start a project</p>
            <h2
              className="text-4xl md:text-5xl lg:text-6xl leading-tight text-white/90 mb-8"
              style={{ fontFamily: "'Instrument Serif', serif" }}
            >
              Let's create something extraordinary together.
            </h2>
            <Link
              to="/consult"
              className="inline-flex items-center gap-2 bg-white text-[#1a1a1a] px-6 py-3 rounded-full text-sm font-medium hover:bg-white/90 transition-colors duration-200"
            >
              Book a Consultation
              <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Links */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-md bg-white flex items-center justify-center">
                <span className="text-[#1a1a1a] font-bold text-sm" style={{ fontFamily: "'Instrument Serif', serif" }}>G</span>
              </div>
              <span className="font-medium text-[15px] tracking-tight">Grapix</span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed">
              A design studio crafting memorable brand experiences through strategic creativity.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-medium tracking-wider uppercase text-white/40 mb-4">Navigation</h4>
            <div className="flex flex-col gap-3">
              {['Portfolio', 'About', 'Blog', 'Consult'].map((item) => (
                <Link
                  key={item}
                  to={`/${item.toLowerCase()}`}
                  className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                >
                  {item}
                </Link>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-medium tracking-wider uppercase text-white/40 mb-4">Services</h4>
            <div className="flex flex-col gap-3">
              {['Brand Identity', 'Web Design', 'Print Design', 'Packaging', 'Motion Graphics', 'Illustration'].map((item) => (
                <span key={item} className="text-sm text-white/60">
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium tracking-wider uppercase text-white/40 mb-4">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@Grapix.studio" className="text-sm text-white/60 hover:text-white transition-colors flex items-center gap-2">
                <Mail size={14} /> hello@Grapix.studio
              </a>
              <span className="text-sm text-white/60 flex items-center gap-2">
                <Phone size={14} /> +1 (555) 234-5678
              </span>
              <span className="text-sm text-white/60 flex items-center gap-2">
                <MapPin size={14} /> San Francisco, CA
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © 2025 Grapix Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Twitter', 'Dribbble', 'Behance', 'Instagram'].map((social) => (
              <a
                key={social}
                href="#"
                className="text-xs text-white/40 hover:text-white transition-colors duration-200"
              >
                {social}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
